<template>
  <content-box width="430px" class="popup__content">
    <div class="invalid-param">
      <i class="icon icon--alert-size50"></i>
      <p class="title">{{ $t('common.validationErrorText.invalidParams') }}</p>
      <ui-button @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </div>
  </content-box>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import ContentBox from '@/components/ui/ContentBox'

export default {
  components: {
    UiButton,
    ContentBox
  },
  methods: {
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.popup__content {
  @include positionXYcenter;
  text-align: center;

  .invalid-param {
    padding: 50px 25px 25px;

    .title {
      margin-top: 15px;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      color: #444444;
    }

    .ui-btn {
      margin-top: 40px;
    }
  }
}
</style>
